import { useAuthContext } from "./use-auth-context";

export const useUser = () => {
  const authContext = useAuthContext();

  const { user } = authContext;

  const id = user?.id || "";

  return {
    id,
  };
};
